const userDefaultBrand = {
	name: "",
	client_config: {
		brand_repo: {
			url: "",
			accountId: "",
			brandId: "",
		},
	},
	list_redirection: {
		logo: {
			id: null,
			width: null,
			type: "",
		},
		styles: {
			"title-color": "",
			"text-color": "",
			buttonTextColor: "",
			buttonBackgroundColor: "",
			"background-color": "",
		},
	},
	smart_email_templates: {
		logo: {
			id: null,
			width: null,
			type: "",
		},
		styles: {
			p_text_color: "",
			page_bg_color: "",
			headline_text_color: "",
			link_color: "",
			button_text_color: "",
			content_bg_color: "",
			button_bg_color: "",
		},
	},
	optin_emails: {
		styles: {},
		logo: {
			id: null,
			width: null,
			type: "",
		},
	},
};

export default userDefaultBrand;
